export const getConfigValue = (values, key) => {
  if (values) {
    const configItem = values.find(item => item.key === key)
    return configItem?.value
  }

  return null
}
